var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_next") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10_All-leagues-",
    transform: "translate(-680, -442)",
    fill: "#BFE82D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(281, 410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(389, 22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_next",
    transform: "translate(13.5, 12) scale(-1, 1) rotate(90) translate(-13.5, -12)translate(7.5, 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8453291,0.178315099 C11.1091956,-0.0594435312 11.5317697,-0.0594435312 11.7955017,0.17834609 C12.0665577,0.422739294 12.0666122,0.824154649 11.8048638,1.05904044 L6.4744968,6.82171487 C6.34576632,6.93770832 6.17539155,7 5.9994277,7 C5.82346386,7 5.65308909,6.93770832 5.5149621,6.81244012 L0.203388104,1.06831518 C-0.0678017663,0.823957759 -0.0678017663,0.422516173 0.203422495,0.178284121 C0.4673254,-0.0593551951 0.88987505,-0.0594017007 1.1635376,0.188258801 L5.99940276,5.4830137 L10.8453291,0.178315099 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.0b12e72926386ad5e95c3deed6c4e328.svg";
export { ForwardRef as ReactComponent };